import { Tool } from './tool';

export class CamTool {
  constructor(
    public hash?: string,
    public name?: string,
    public tool?: Tool,
    public toolName?: string
  ) { }

  clone() {
    return new CamTool (
      this.hash,
      this.name,
      this.tool,
      this.toolName
    );
  }

  get filterableData() {
    return `${ this.toolName } ${ this.name }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cam-tool.ts